import React from 'react';
import { Typography, Box } from '@mui/material';
import PolymarketItemCard from './PolymarketItemCard';
import FarcasterItemCard from './FarcasterItemCard';
import ZoraCoinCard from './ZoraCoinCard';
import PolymarketWalletCard from './PolymarketWalletCard';
import KalshiItemCard from './KalshiItemCard';
import KalshiWalletCard from './KalshiWalletCard';
import TokenItemCard from './TokenItemCard';
import WalletUsersCard from './WalletUsersCard';
import FarcasterUserCard from './FarcasterUserCard';
import AlphaNotificationCard from './AlphaNotificationCard';
import NotificationHyperliquidWalletsCard from './NotificationHyperliquidWalletsCard';
import NotificationHyperliquidPositionsCard from './NotificationHyperliquidPositionsCard';
import HyperliquidItemCard from './HyperliquidItemCard';
import HyperliquidMarketCard from './HyperliquidMarketCard';


const CardRouter = ({ hit }) => {

  const index = hit._index;

  const findCardComponent = () => {
    // Order matters: longer / more specific prefixes must come before shorter
    // ones (e.g. notification-hyperliquid-wallet-positions before
    // notification-hyperliquid-wallets). The trade-event and notifications
    // entries catch both the underlying `alpha-*` indexes and the friendly
    // `<chain>-trades` / `<chain>-notifications` aliases.
    const componentMap = {
      'farcaster-items': FarcasterItemCard,
      'farcaster-users': FarcasterUserCard,
      'zora-coins': ZoraCoinCard,
      'polymarket-items': PolymarketItemCard,
      'token-items': TokenItemCard,
      'wallet-users': WalletUsersCard,
      'polymarket-wallets': PolymarketWalletCard,
      'kalshi-items': KalshiItemCard,
      'kalshi-wallets': KalshiWalletCard,
      // Wallet/position aliases — list the more specific (-wallet-positions)
      // before the wallets prefix so the position card is preferred.
      'notification-hyperliquid-wallet-positions': NotificationHyperliquidPositionsCard,
      'notification-hyperliquid-wallets': NotificationHyperliquidWalletsCard,
      'hyperliquid-wallet-positions': NotificationHyperliquidPositionsCard,
      'hyperliquid-wallets': NotificationHyperliquidWalletsCard,
      // Notifications: alpha-notifications-{dex,polymarket,hyperliquid,kalshi}
      // + friendly aliases {dex,polymarket,hyperliquid,kalshi}-notifications.
      'alpha-notifications-': AlphaNotificationCard,
      'dex-notifications': AlphaNotificationCard,
      'polymarket-notifications': AlphaNotificationCard,
      'hyperliquid-notifications': AlphaNotificationCard,
      'kalshi-notifications': AlphaNotificationCard,
      // Trade events: alpha-trade-events-{hyperliquid,polymarket,base,ethereum,solana}
      // + friendly aliases {hyperliquid,polymarket,base,ethereum,solana}-trades.
      // Hyperliquid perp/spot markets metadata. Must be listed before any
      // shorter `hyperliquid-` prefix entry (none today, but defensive).
      'hyperliquid-items': HyperliquidMarketCard,
      'alpha-trade-events-': HyperliquidItemCard,
      'hyperliquid-trades': HyperliquidItemCard,
      'polymarket-trades': HyperliquidItemCard,
      'base-trades': HyperliquidItemCard,
      'ethereum-trades': HyperliquidItemCard,
      'solana-trades': HyperliquidItemCard,
    };
    for (const [x, component] of Object.entries(componentMap)) {
      if (index.startsWith(x)) {
        return component;
      }
    }
    return null;
  }

  const Component = findCardComponent(index);
  if (Component) {
    return <Component hit={hit}  />;
  }
  return (
    <Box
      sx={{
        p: 2,
        mb: 2,
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: 1,
        color: '#856404'
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        ⚠️ Unhandled Index Type {index}
      </Typography>
      <Typography variant="caption" color="inherit">
        {JSON.stringify(hit)}
      </Typography>
    </Box>
  );

}

export default CardRouter;
